import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, message } from 'antd';

const CloseableErrorMessage = (textToShow, showSupport = false) => {
  message.error({
    key: 'errorMsg',
    content: (
      <span>
        {textToShow}
        {'\u00A0'}
        {showSupport && (<Button
          id="EmailFeedbackButton"
          className="margin-none"
          type="link"
          href="mailto:support@govenda.com"
          onClick={() => window.open('mailto:support@govenda.com')}
          style={{marginBottom: 10, marginLeft: 4, padding: 0}}
        >
          Click here to contact Govenda support
        </Button>)}
        <FontAwesomeIcon
          className="message-close"
          icon={faTimes}
        />
      </span>
    ),
    duration: 0,
    onClick: () => { message.destroy('errorMsg') },
  });

  const handleClickOutside = e => {
    message.destroy('errorMsg')
  };

  document.addEventListener('mousedown', handleClickOutside);
}

export default CloseableErrorMessage;